// src/pages/UssdSummary.js
import React, { useEffect, useState, useRef } from "react";

export default function UssdSummary() {
  const [loading, setLoading] = useState(true);
  const [embedUrl, setEmbedUrl] = useState(process.env.REACT_APP_METABASE_EMBED_URL || "");
  const [error, setError] = useState(null);
  const iframeRef = useRef();

  useEffect(() => {
    setError(null);
    setLoading(Boolean(!embedUrl));
  }, [embedUrl]);

  const handleRefresh = () => {
    try {
      if (iframeRef.current) {
        // reload iframe
        iframeRef.current.src = iframeRef.current.src;
      }
    } catch (e) {
      console.warn("iframe reload failed", e);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        {/* <h2 style={{ margin: 0 }}>USSD Summary</h2> */}
        <div style={styles.headerRight}>
          <button style={styles.refreshBtn} onClick={handleRefresh}>
            Refresh Report
          </button>
        </div>
      </div>

      {!embedUrl && (
        <div style={styles.placeholder}>
          <p style={{ margin: 0 }}>
            No Metabase embed URL configured. Set <code>REACT_APP_METABASE_EMBED_URL</code> in your frontend <code>.env</code>.
          </p>
        </div>
      )}

      {embedUrl && (
        <div style={styles.iframeWrap}>
          {loading && <div style={styles.loading}>Loading report…</div>}
          <iframe
            ref={iframeRef}
            title="USSD Summary - Metabase"
            src={embedUrl}
            style={styles.iframe}
            frameBorder="0"
            onLoad={() => setLoading(false)}
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
          />
        </div>
      )}

      {error && <div style={{ color: "crimson", marginTop: 12 }}>Error: {error}</div>}
    </div>
  );
}

const styles = {
  container: { padding: 18, height: "100%", boxSizing: "border-box" },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
  },
  headerRight: { display: "flex", gap: 8 },
  refreshBtn: {
    background: "#2563eb",
    color: "#fff",
    border: "none",
    padding: "8px 12px",
    borderRadius: 6,
    cursor: "pointer",
  },
  placeholder: {
    padding: 18,
    background: "#fff",
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
  },
  iframeWrap: {
    height: "calc(100vh - 160px)",
    background: "#fff",
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    overflow: "hidden",
    position: "relative",
  },
  loading: {
    position: "absolute",
    zIndex: 2,
    background: "rgba(255,255,255,0.9)",
    width: "100%",
    textAlign: "center",
    padding: 12,
  },
  iframe: {
    width: "100%",
    height: "100%",
    border: 0,
    display: "block",
  },
};
